import { useState } from "react";

/**
 * 语音相关状态 Hook
 */
const useVoiceState = () => {
  const [isVoiceRecording, setIsVoiceRecording] = useState(false);
  const [isVoiceProcessing, setIsVoiceProcessing] = useState(false);

  // 重置语音状态
  const resetVoiceState = () => {
    setIsVoiceRecording(false);
    setIsVoiceProcessing(false);
  };

  return {
    isVoiceRecording,
    setIsVoiceRecording,
    isVoiceProcessing,
    setIsVoiceProcessing,
    resetVoiceState,
  };
};

export default useVoiceState;
